"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function StartYourJourney() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });
  return <section id="start-your-journey" className="dark bg-background text-foreground relative flex min-h-[50vh] items-center justify-center overflow-hidden px-6 py-24 md:py-32">
      {}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
      backgroundImage: "repeating-linear-gradient(45deg, transparent, transparent 10px, var(--color-primary) 10px, var(--color-primary) 11px)"
    }} aria-hidden="true" />

      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary/10 rounded-full blur-[120px] pointer-events-none" aria-hidden="true" />

      <div ref={ref} className={`relative z-10 mx-auto flex max-w-3xl flex-col items-center text-center transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
        <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-border/50 bg-muted/30 px-3 py-1 text-xs font-medium tracking-wider text-muted-foreground uppercase backdrop-blur-md">
          <span className="size-1.5 rounded-full bg-primary animate-pulse" />
          DB Hockey Advancement
        </div>

        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1575279/img/image_4rbkzwk0.png" className="h-7 mb-6" alt="DB Hockey Advancement" />

        <h1 className="mb-6 text-5xl font-black tracking-tighter text-foreground uppercase md:text-7xl lg:text-8xl drop-shadow-sm">
          Prospect <br className="hidden md:block" />
          <span className="text-transparent bg-clip-text bg-gradient-to-br from-foreground to-muted-foreground">Intake</span>
        </h1>

        {}
        <div className="mb-8 h-1.5 w-24 -skew-x-12 bg-primary shadow-[0_0_15px_var(--color-primary)]" aria-hidden="true" />

        <p className="max-w-2xl text-lg leading-relaxed text-muted-foreground md:text-xl">
          Accuracy is paramount. The information provided below serves as the foundation for your scouting profile. Ensure all details are precise to help our team evaluate your potential and identify the optimal advancement pathways for your hockey career.
        </p>
      </div>
    </section>;
}